// extracted by mini-css-extract-plugin
export default {"btn":"LikeOrNot_btn__X4McN","btnLike":"LikeOrNot_btnLike__4EokE","btnDisLike":"LikeOrNot_btnDisLike__YcqAG","btnOn":"LikeOrNot_btnOn__neVZT"};